import apps from '../assets/icons/apps.svg?raw';
import angleRight from '../assets/icons/angle-right.svg?raw';
import check from '../assets/icons/check.svg?raw';
import times from '../assets/icons/times.svg?raw';
import shieldCheck from '../assets/icons/shield-check.svg?raw';

const icons = Object.freeze({ apps, 'angle-right': angleRight, check, times, 'shield-check': shieldCheck });

/** Bundled Unicons SVGs and the project's shield-check artwork. */
export function createInterfaceIcon(name, ownerDocument) {
  const template = ownerDocument.createElement('template');
  template.innerHTML = icons[name];
  const icon = template.content.firstElementChild;
  icon.classList.add('positive-nav-icon');
  icon.setAttribute('aria-hidden', 'true');
  icon.setAttribute('focusable', 'false');
  return icon;
}
